import form from "./form";


const {
    formField: {
        groupId,
        casinoId,
        groupName
    },
} = form;

const initialValues = {
    [groupId.name]: "",
    [casinoId.name]: "",
    [groupName.name]: ""
};

export default initialValues;
